import { useFeatureFlag } from './useFeatureFlag';

interface UseReportVisibleArgs {
    flagKey: string;
    canSee: boolean | undefined;
    isReOpsUser: boolean;
}

export const useReportVisible = ({
    flagKey,
    canSee,
    isReOpsUser,
}: UseReportVisibleArgs): boolean | undefined => {
    const flagEnabled = useFeatureFlag(flagKey);

    if (canSee === undefined) {
        return undefined;
    }

    if (!canSee) {
        return false;
    }

    if (isReOpsUser) {
        return true;
    }

    if (flagEnabled === null) {
        return undefined;
    }

    return flagEnabled === true;
};
